// extracted by mini-css-extract-plugin
module.exports = {"div":"paginator_div__1-G5g"};